module.exports = Object.keys || require('./shim');




//////////////////
// WEBPACK FOOTER
// ./~/level-ws/~/object-keys/index.js
// module id = 1489
// module chunks = 0 1 2